import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';
import { getAuthState, getGeoLocation } from '@sxm-de/dev-kits/web-sdk/utils';

export type GetDefaultRegionCodeFn = () => Promise<{
    regionCode: string;
    countryCode: string;
}>;

export function initGetDefaultRegionCodeFn({
    dependencies,
}: DomainInitPayload): GetDefaultRegionCodeFn {
    return async () => {
        try {
            if (getAuthState() === 'anonymous') {
                throw new Error('SYSTEM');
            }
            const {
                serviceAddress: { state: regionCode, country: countryCode },
            } = await getDefaultBillingProfile(dependencies);
            return { regionCode, countryCode };
        } catch (error: any) {
            const { regionCode = '', countryCode = '' } =
                getGeoLocation() || {};
            return { regionCode, countryCode };
        }
    };
}
